<template>
  <div class="divMargin">
    <div class="header">
      <p id="hrighttitle">“Yol-nəqliyyat hadisəsində zərərçəkənin idarə<br> etdiyi avtonəqliyyat vasitəsinə dəyən
        zərərin<br>
        ödənilməsi ilə bağlı sığortaçılar arasında <br> qarşılıqlı ödəmələrin tənzimlənməsinə dair <br> Kollektiv Saziş”ə
        4
        nömrəli Əlavə</p>
      <h1 id="hrightform">FORMA</h1>
      <p style="font-weight: bold;font-size: 16pt;">Yol-nəqliyyat hadisəsində zərərçəkənin idarə etdiyi avtonəqliyyat
        vasitəsinə dəyən
        zərərin ödənilməsi ilə
        bağlı</p>
      <p style="font-weight: bold;font-size: 16pt;">ÖDƏNİŞ AKTI : {{ item.dispClaimNumber }}</p>
    </div>
    <div class="content">
      <div class="footer">
        <div style="display: flex; justify-content: space-between;">
          <span>Tarix:{{ currentDateTime }}</span>
          <span>Bakı şəhəri</span>
        </div>
      </div>

      <div class="section">
        <p class="section-title">I. SİĞORTA ŞƏHADƏTNAMƏSİ ÜZRƏ ÜMUMİ MƏLUMATLAR:</p>
        <div class="info-row">
          <p class="info-title"><strong>1. {{$t('Sığorta_növü')}}:</strong></p>
          <p class="info-value">
            {{ item.insuranceTypeName === 'İcbari' ? 'Avtonəqliyyat vasitəsi sahiblərinin mülki məsuliyyətinin icbari sığortası' : item.insuranceTypeName }}
          </p>

        </div>
        <div class="info-row">
          <p class="info-title"><strong>2. Zərərvuranın sığortaçısı:</strong></p>
          <p class="info-value">{{ item.insCompName }}</p>
        </div>

        <div class="info-row">
          <p class="info-title"><strong>3. Zərərvuranın Sığorta şəhadətnaməsi No:</strong></p>
          <p class="info-value">{{ item.insPolicyNumber }}</p>
        </div>
        <div class="info-row">
          <p class="info-title"><strong>4. Zərərvuran:</strong></p>
          <p class="info-value"> {{ item.injuredName }}</p>
        </div>

        <div class="info-row">
          <p class="info-title"><strong>5. Zərərvuranın avtonəqliyyat vasitəsinin məlumatları:</strong></p>
          <p class="info-value"> {{ item.injuredDisplayName }}</p>
        </div>
        <div class="info-row">
          <p class="info-title"><strong>6. Zərərçəkənin sığortaçısı:</strong></p>
          <p class="info-value">{{ item.osCompName }}</p>
        </div>
        <div class="info-row">
          <p class="info-title"><strong>7. Zərərçəkənin Sığorta Şəhadətnaməsi No:</strong></p>
          <p class="info-value"> {{ item.osPolicyNumber }}</p>
        </div>
        <div class="info-row">
          <p class="info-title"><strong>8. Zərərçəkən:</strong></p>
          <p class="info-value">{{ item.victimName
          }}</p>
        </div>
        <div class="info-row">
          <p class="info-title"><strong>9. Zərərçəkənin avtonəqliyyat vasitəsinin məlumatları:</strong></p>
          <p class="info-value">{{ item.victimDisplayName }}</p>
        </div>
        <div class="info-row">
          <p class="info-title"><strong>10. Zərərçəkənin zərərdə payı: </strong></p>
          <p class="info-value">
            <template>
              <label>
                <input type="checkbox" class="custom-checkbox" :checked="item.bothVictim === 1" disabled> 50%
              </label>
              &nbsp; &nbsp; &nbsp; &nbsp;
              <label>
                <input type="checkbox" class="custom-checkbox" :checked="item.bothVictim === 0" disabled> 100%
              </label>
            </template>
          </p>
        </div>


        <p class="section-title">II. SIĞORTA HADİSƏSİNİN TƏFƏRRÜATI:</p>
        <div class="info-row">
          <p class="info-title"><strong>1. Hadisənin baş vermə tarixi və vaxtı:</strong></p>
          <p class="info-value">{{ item.accidentDateStr
          }}</p>
        </div>
        <div class="info-row">
          <p class="info-title"><strong>2. Hadisənin baş verdiyi yer:</strong></p>
          <p class="info-value">{{ item.place
          }}</p>
        </div>

        <div class="info-row">
          <p class="info-title"><strong>3. Hadisənin təsviri:</strong></p>
          <p class="info-value">{{ item.damageCategoryName
          }}</p>
        </div>
        <div class="info-row">
          <p class="info-title"><strong>4. Hadisəni qeydə alan orqan: </strong></p>
          <p class="info-value">{{ item.officialAgencyName
          }}</p>
        </div>

        <p class="section-title">III. DƏYMİŞ ZƏRƏR:</p>
        <div class="info-row">
          <p class="info-title"><strong>1. Daşınma və ekspertiza xərci: </strong></p>
          <p class="info-value">0 AZN</p>
        </div>
        <p class="section-title">IV. ÖDƏNİŞ:</p>
        <div class="info-row">
          <p class="info-title"><strong>1. Ödənişin məbləği:</strong></p>
          <p class="info-value">{{ item.paymentSumLetter
          }}</p>
        </div>
        <div class="info-row">
          <p class="info-title"><strong>2. Məbləği alan:</strong></p>
          <p class="info-value">{{ item.paymentReceivedPerson
          }}</p>
        </div>

        <div class="info-row">
          <p class="info-title"><strong>3. Bank adı və filialı:</strong></p>
          <p class="info-value">{{ item.bankName
          }}</p>
        </div>
        <div class="info-row">
          <p class="info-title"><strong>4. Hesab nömrəsi:</strong></p>
          <p class="info-value">{{ item.accountNumber
          }}</p>
        </div>

        <div class="info-row">
          <p class="info-title"><strong>5. Zərərçəkən/Məbləği alan şəxs: </strong></p>
          <p class="info-value">{{ item.paymentReceivedPerson
          }}</p>
        </div>
      </div>
      <p class="section-title">V. YEKUN MÜDDƏALAR:</p>
      <p><strong>1. Məbləği alan şəxs təsdiq edir ki, baş vermiş sığorta hadisəsi nəticəsində ona dəymiş zərərin
          əvəzinin ödənilməsi üçün heç bir digər ödəniş almır və bu aktda nəzərdə tutulmuş ödənişi həyata keçiriləndən
          sonra onun bu sığorta hadisəsi ilə bağlı heç bir iddiası yoxdur. </strong></p>

      <h4>Biz aşağıda imza edənlər, bu aktın həqiqiliyini və etibarlılığını təsdiq edirik:</h4>

      <table>
        <tr>
          <th>İmzalayanın vəzifəsi</th>
          <td>Sığorta İddialarının Tənzimlənməsi Şöbəsi – Mütəxəssis</td>
        </tr>
        <tr>
          <th>İmzalayanın tam adı</th>
          <td>{{ item.clientServiceUserName }}</td>
        </tr>
        <tr>
          <th>İmza və tarix</th>
          <td class="signature-date"></td>
        </tr>
        <tr>
          <th>İmzalayanın vəzifəsi</th>
          <td>Sığorta İddialarının Tənzimlənməsi Şöbəsinin Müdiri</td>
        </tr>
        <tr>
          <th>İmzalayanın tam adı</th>
          <td>Etibar Sofiyev</td>
        </tr>
        <tr>
          <th>İmza və tarix</th>
          <td class="signature-date"></td>
        </tr>
        <tr>
          <th>İmzalayanın vəzifəsi</th>
          <td>Sığorta İddiaları Departamentinin Direktoru</td>
        </tr>
        <tr>
          <th>İmzalayanın tam adı</th>
          <td>Vüsal Kərimov</td>
        </tr>
        <tr>
          <th>İmza və tarix</th>
          <td class="signature-date"></td>
        </tr>
        <tr>
          <th>İmzalayanın vəzifəsi</th>
          <td>Sədrin Müşaviri</td>
        </tr>
        <tr>
          <th>İmzalayanın tam adı</th>
          <td>Ceyhun Qurbanlı</td>
        </tr>
        <tr>
          <th>İmza və tarix</th>
          <td class="signature-date"></td>
        </tr>
        <tr>
    <td colspan="2" class="note">
      Qeyd: Yuxarıda qeyd edilmiş imzalayacaq şəxslərin sayı Sığorta şirkəti tərəfindən müəyyən edilir
    </td>
  </tr>
        <tr>
          <th>Zərərçəkən/Məbləği alan şəxs:</th>
          <td>{{ item.paymentReceivedPerson }}</td>
        </tr>
        <tr>
          <th>İmza/möhür və tarix:</th>
          <td></td> 
        </tr>
        <tr>
          <th>FİN kodu /VÖEN:</th>
          <td class="signature-date">{{ item.paymentIdentNumber }}</td>
        </tr>
      </table>



    </div>
  </div>
</template>
 
 
 
<script>
export default {
  props: {
    value: Object,
  },
  data() {
    return {
      item: this.value,
      currentDateTime: new Date().toLocaleString('tr-TR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      }),
    };
  },
  watch: {
    value() {
      this.item = this.value;
    },
  },
};
</script>
 
<style lang="scss" scoped>
body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: black;
  /* Set default text color to black */
  text-align: left;
  background-color: #fff;
}

.custom-checkbox {
  width: 20px;
  /* Checkbox genişliği */
  height: 20px;
  /* Checkbox yüksekliği */
  vertical-align: middle;
  /* Diğer içerikle ortalamak için */
  margin-right: 5px;
  /* Checkbox ve yazı arasındaki mesafe */
}

.header {
  font-size: 18px;
  text-align: center;
  margin-bottom: 2px;
  color: black;
  /* Set text color to black */
}

.note {
  font-size: smaller; /* Daha küçük font boyutu */
  text-align: left; /* Metni sola hizala */
  width: 50%; /* Veya istediğiniz başka bir genişlik */
  padding: 5px; /* İç boşluğu ayarla */
  box-sizing: border-box; /* Padding'i genişliğe dahil et */
}


.content {
  font-size: 16px;
  color: black;
  /* Set text color to black */
}

.footer {
  text-align: right;
  margin-top: 2px;
  font-weight: bold;
  color: black;
  /* Set text color to black */
}

.footer>div {
  display: flex;
  justify-content: space-between;
}

.section-title {
  font-weight: bold;
  margin-top: 10px;
  text-decoration: underline;
  color: black;
  /* Set text color to black */
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  color: black;
  /* Set text color to black */
}

table,
th,
td {
  border: 1px solid black;
  color: black;
  font-size: 15pt;
  /* Set text color to black */
}

th,
td {
  font-size: 15pt;
  padding: 20px;
  text-align: left;
  color: black;
  /* Set text color to black */
}

#hrighttitle {
  text-align: right;
  font-weight: bold;
  color: black;
  font-size: 16pt;
  /* Set text color to black */
}

#hrightform {
  color: black;
  /* Set text color to black */
  font-size: smaller;
  text-align: right;
}

.info-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 2px;
}

.info-title,
.info-value {
  width: 50%;
  margin: 0;
}

.info-title {
  text-align: left;
  padding-right: 10px;
  font-size: 15pt;
}

.info-value {
  text-align: left;
  padding-left: 10px;
  font-size: 15pt;
}

@media print {
  .divMargin {
    padding: 5% !important;
  }
}

.divMargin {
  padding: 5%;
}

h4 {
  text-decoration: underline;
  color: black;
  /* Set text color to black */
}
</style>

 
 